/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { createBigNumberClass } from '../../factoriesAny.js';
export var BigNumberDependencies = {
  createBigNumberClass
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesBigNumberClass.generated.js
// module id = qMP7
// module chunks = 3